export default {
  "content": "<path d=\"M23.759 14.15l-6 7a1 1 0 01-1.518 0l-3-3.5 1.518-1.3L17 18.964l5.241-6.114 1.518 1.3z\" fill=\"#7B61FF\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M19 3a2 2 0 012 2v6.5h-2V10H5v9h6.5v2H5a2 2 0 01-2-2V5a2 2 0 012-2h14zM5 8h14V5H5v3z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};